/** Stub for CDN bundle: no-op analytics */
export function fireTag() {}
export function loadTagLibrary() {}
